import BaseModel from "./base/baseModel";

export default class TelaAcaoUsuarioModel extends BaseModel {
    id?: number = null;
    telaAcaoId?: number = null;
    usuarioId?: number = null;
    telaAcaoDescricao = "";
}
